import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare } from "lucide-react";
import { ManagedCampaignData } from "./ManagedCampaignData";
import { SequenceTimeline } from "@/components/simplified-onboarding/SequenceTimeline";

interface ManagedSequenceStepProps {
  data: ManagedCampaignData;
  updateData: (updates: Partial<ManagedCampaignData>) => void;
  isPremium?: boolean;
}

export const ManagedSequenceStep = ({ data, updateData, isPremium = false }: ManagedSequenceStepProps) => {
  // Standard variables available for managed campaigns
  const availableVariables = ['first_name', 'last_name', 'company', 'title'];

  return (
    <div className="space-y-6">
      <SequenceTimeline
        sequences={data.sequences}
        onChange={(sequences) => updateData({ sequences })}
        availableVariables={availableVariables}
        isPremium={isPremium}
      />
    </div>
  );
};
